export default {
  name: "MainFeatureCard",
  props: [
    "featureText",
    "featureIcon",
    "featureLink",
    "isExternal",
    "ctaText",
    "headline"
  ]
};



// WEBPACK FOOTER //
// ./src/components/landing/landingComponents/mainFeatureCard.js